import React from "react";
import { formatDateOnly } from "helpers/dateOnly";
import { Box, Flex, Badge } from "theme-ui";
import CalendarIcon from "components/svg/icons/CalendarIcon";
import P from "components/typography/P";
import { themevals } from "theme/themevals";

interface ProjectCardProps {
  id: string;
  projectNumber: string;
  projectName: string;
  status: string;
  statusColor: string;
  serviceDate: string | null;
  locationAddress?: string;
}

const ProjectCard: React.FC<ProjectCardProps> = ({
  id,
  projectNumber,
  projectName,
  status,
  statusColor,
  serviceDate,
  locationAddress,
}) => {
  const handleProjectClick = (e: React.MouseEvent) => {
    e.preventDefault();
    window.open(`/projects/${id}`, "_blank");
  };

  return (
    <Box
      sx={{
        backgroundColor: "white",
        border: "1px solid",
        borderColor: themevals.colors.inputOutline,
        borderRadius: "8px",
        boxShadow: "0px 0px 12px 4px rgba(129, 129, 129, 0.07)",
        overflow: "hidden",
      }}
    >
      {/* Card Header with Project Number and Status Badge */}
      <Flex
        sx={{
          alignItems: "center",
          justifyContent: "space-between",
          padding: "16px",
          borderBottom: "1px solid",
          borderColor: themevals.colors.inputOutline,
        }}
      >
        <Box
          onClick={handleProjectClick}
          sx={{
            fontFamily: "Poppins",
            fontSize: "13px",
            fontWeight: "600",
            color: "black",
            textDecoration: "underline",
            cursor: "pointer",
            "&:hover": {
              color: themevals.colors.primary,
            },
          }}
        >
          {projectNumber}
        </Box>
        <Badge variant={statusColor}>{status}</Badge>
      </Flex>

      {/* Card Content */}
      <Box sx={{ padding: "16px" }}>
        {/* Project Name */}
        <P
          fontFamily="Poppins"
          fontSize="14px"
          fontWeight="600"
          color="black"
          marginTop="0"
          marginBottom="12px"
          sx={{
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
            minHeight: "40px",
          }}
        >
          {projectName}
        </P>

        {/* Service Date */}
        {serviceDate && (
          <Flex sx={{ alignItems: "center", gap: "6px", marginTop: "auto" }}>
            <CalendarIcon width={14} height={14} fill={themevals.colors.dkgrey} />
            <P
              fontFamily="Poppins"
              fontSize="13px"
              color={themevals.colors.dkgrey}
              marginTop="0"
              marginBottom="0"
            >
              {serviceDate ? formatDateOnly(serviceDate) : null}
            </P>
          </Flex>
        )}
      </Box>
    </Box>
  );
};

export default ProjectCard;
